module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/communications/create-dialog-communications/create.dialog.communications.component.css
// module id = ./src/app/components/dashboard/communications/create-dialog-communications/create.dialog.communications.component.css
// module chunks = main